import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { HeaderBasicAuthorizationService } from '../../../../../shared/services/header-basic-authorization.service';
import { ApiEnum } from '../../../../../shared/enums/api.enum';
@Injectable({
  providedIn: 'root'
})
export class HorarioService {

  constructor(
    private http: HttpClient,
    private headerBasicAuthorization: HeaderBasicAuthorizationService
  ) {
  }
  public GetDiaSemana(){
    return this.http.get(`${environment.api.WS_HCM.url}/Horario/GetDiaSemana`,{
    headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe( map( data => data ));
  }

  public ListarHorario(){
    return this.http.get(`${environment.api.WS_HCM.url}/Horario/ListarHorario`,{
    headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe( map( data => data ));
  }

  public SaveUpdateHorario(model){
    return this.http.post(`${environment.api.WS_HCM.url}/Horario/SaveUpdateHorario`,model,{
    headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe( map( data => data ));
  }

  public GetHorarioById(Horario){
    return this.http.get(`${environment.api.WS_HCM.url}/Horario/GetHorarioById?prmintHorario=${Horario}`,{
    headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe( map( data => data ));
  }

  public BuscarPersonalByDNI(DNI){
    return this.http.get(`${environment.api.WS_HCM.url}/Horario/BuscarPersonalByDNI?prmstrDNI=${DNI}`,{
    headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe( map( data => data ));
  }

  public SaveUpdateAsignacionHorario(model){
    return this.http.post(`${environment.api.WS_HCM.url}/Horario/SaveUpdateAsignacionHorario`,model,{
    headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe( map( data => data ));
  }

  public EnableDisableHorario(model){
    return this.http.post(`${environment.api.WS_HCM.url}/Horario/EnableDisableHorario`,model,{
    headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe( map( data => data ));
  }

  public EnableDisableAsignacion(model){
    return this.http.post(`${environment.api.WS_HCM.url}/Horario/EnableDisableAsignacion`,model,{
    headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe( map( data => data ));
  }

  public getListarHorarios() {
    return this.http.get(`${environment.api.WS_HCM.url}/Horario/getListarHorarios`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getListarPersonalHorario(model) {
    return this.http.post(`${environment.api.WS_HCM.url}/Horario/getListarPersonalHorario`, model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public registroMasivoHorarioPersonal(model) {
    return this.http.post(`${environment.api.WS_HCM.url}/Horario/registroMasivoHorarioPersonal`, model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
}